import { getKreaMyResources, getKreaSchoolsGroupResources } from '../../services/Krea'
import { isError } from '../../utils/api'

export default {
  state: {
    myResources: {
      totalCount: 0,
      resources: []
    },
    schoolsGroupResources: {
      totalCount: 0,
      resources: []
    }
  },

  mutations: {
    hydrateKreaMyResources(state, data) {
      state.myResources.resources = [...state.myResources.resources, ...data.data]
      state.myResources.totalCount = data.totalCount
    },
    hydrateKreaSchoolsGroupResources(state, data) {
      state.schoolsGroupResources.resources = [...state.schoolsGroupResources.resources, ...data.data]
      state.schoolsGroupResources.totalCount = data.totalCount
    },
    clearKreaResources(state) {
      state.schoolsGroupResources.resources = []
      state.schoolsGroupResources.totalCount = 0
      state.myResources.resources = []
      state.myResources.totalCount = 0
    }
  },

  actions: {
    async hydrateKreaMyResources({ commit }, params = {}) {
      const response = await getKreaMyResources(params).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('hydrateKreaMyResources', response.data)
      return successfulRequest
    },
    async hydrateKreaSchoolsGroupResources({ commit }, params = {}) {
      const response = await getKreaSchoolsGroupResources(params).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('hydrateKreaSchoolsGroupResources', response.data)
      return successfulRequest
    },
    clearKreaResources({ commit }) {
      commit('clearKreaResources')
    }
  }
}
